import CalendarService from '@services/CalendarService'

class TitlePatternUtility

  @DEFAULT_TITLE_PATTERN = '{{title}}'
  @TOKENS = [
    'title'
    'venue'
    'city'
    'state'
    'host'
    'org'
    'team'
    'start date'
  ]

  @extractTokensFromPattern: (titlePattern) ->
    tokenRegex = /\{\{(.+?)\}\}/g
    tokens = [...titlePattern.matchAll(tokenRegex)]
    tokens = tokens.map((match) => match[1])
    tokens

  @replacePatternTokens: (titlePattern, mapTokenValues) ->
    replacedTitle = titlePattern
    tokens = @extractTokensFromPattern titlePattern
    for token in tokens
      replaceRegex = new RegExp "\{\{#{token}\}\}", 'g'
      replaceValue = mapTokenValues[token]
      replaceValue ||= ''
      replacedTitle = replacedTitle.replace replaceRegex, replaceValue
    replacedTitle

  @getAllTokens: ->
    [...@TOKENS]

  @mapAvailabilityTokenValues: (availability) ->
    title: availability.title
    venue: availability.venue_name
    city: availability.venue_city
    state: availability.venue_state
    host: availability.host
    org: availability.ctx?.top_org?.name
    team: availability.ctx?.team?.name
    'start date': dayjs(availability.dates[0].starts_on).format(CalendarService.DISPLAY_DATE_FORMAT) if availability.dates?[0]?.starts_on

  @formatAvailabilityTitle: (availability) ->
    return '' unless availability
    pattern = availability.title_pattern
    pattern ||= @DEFAULT_TITLE_PATTERN
    mapTokenValues = @mapAvailabilityTokenValues availability 
    @replacePatternTokens pattern, mapTokenValues

  @mapListingTokenValues: (listing) ->
    title: listing.title
    venue: listing.venue_name
    city: listing.city
    state: listing.state
    host: listing.host
    org: listing.org?.name
    team: listing.team?.name
    'start date': dayjs(listing.calendar_dates[0].starts_on).format(CalendarService.DISPLAY_DATE_FORMAT) if listing.calendar_dates?[0]?.starts_on

  @formatListingTitle: (listing) ->
    return '' unless listing
    pattern = listing.title_pattern
    pattern ||= @DEFAULT_TITLE_PATTERN
    mapTokenValues = @mapListingTokenValues listing 
    @replacePatternTokens pattern, mapTokenValues

export default TitlePatternUtility
